import classNames from "classnames";
import type { ReactNode } from "react";

export function PageHeading({
  title,
  actions = undefined,
  bordered = false,
  description = "",
  className,
}: {
  title: ReactNode;
  actions?: ReactNode;
  description?: string;
  bordered?: boolean;
  className?: string;
}) {
  return (
    <div
      className={classNames(
        bordered && "pb-5 border-b border-border",
        "flex items-center justify-between mb-5 flex-wrap",
        className,
      )}
    >
      <div className="flex-1 min-w-0">
        <h2 className="text-foreground md:text-2xl md:truncate text-xl font-bold">{title}</h2>
        {description && <p className="text-muted-foreground text-sm">{description}</p>}
      </div>
      <div className="flex ml-4">{actions}</div>
    </div>
  );
}

export default PageHeading;
